module.exports = __webpack_public_path__ + "img/HZ-T1314.db5febbc.jpg";